<script setup lang="ts">
import { computed } from 'vue';

import AzureIcon from '@/assets/azure.svg';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';
import type { UserGroup } from '@/services/user_groups';

import AzureGroupMembersView from './AzureGroupMembersView.vue';

interface Props {
    open: boolean;
    group: UserGroup | null;
    tenantId: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:open']);

const isOpen = computed({
    get: () => props.open,
    set: (value) => emit('update:open', value)
});

// Convert UserGroup to AzureGroup format for the view component
const azureGroup = computed(() => {
    if (!props.group || !props.group.azure_group_id) return null;

    return {
        id: props.group.azure_group_id,
        displayName: props.group.name,
        description: props.group.description,
        mail: undefined
    };
});
</script>

<template>
    <Dialog v-model:open="isOpen">
        <DialogContent class="max-w-2xl h-[90vh] flex flex-col">
            <DialogHeader>
                <DialogTitle class="flex items-center gap-2">
                    <img :src="AzureIcon" class="w-5 h-5" alt="Azure" />
                    <span>{{ group?.name || 'View Group Members' }}</span>
                </DialogTitle>
            </DialogHeader>

            <div class="flex-1 min-h-0 overflow-hidden pt-2">
                <AzureGroupMembersView
                    v-if="azureGroup"
                    :group="azureGroup"
                    :tenant-id="tenantId"
                />
            </div>
        </DialogContent>
    </Dialog>
</template>
